import * as Handlebars from "handlebars";

export const registerHandlebarsHelpers = () => {

  Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
    return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
  });
  Handlebars.registerHelper('ifNotEquals', function(arg1, arg2, options) {
    return ((arg1 || "") != arg2) ? options.fn(this) : options.inverse(this);
  });

  Handlebars.registerHelper('ifNotEmpty', function(value, options) {
    return (value === "" || value === undefined || value == null) ?  options.inverse(this) : options.fn(this);
  });

  Handlebars.registerHelper('ifEmpty', function(value, options) {
    return (value === "" || value === undefined || value == null) ?  options.fn(this) : options.inverse(this);
  });

  Handlebars.registerHelper('ifTrue', function(arg1, options) {
    return (arg1 == "True" || arg1 === true) ? options.fn(this) : options.inverse(this);
  });
  Handlebars.registerHelper('ifNotTrue', function(arg1, options) {
    return ((arg1 || "") == "False" || (arg1 || "") === false) ? options.fn(this) : options.inverse(this);
  });
};